export * from './ProductHero';

import { ProductHero } from './ProductHero';

export default ProductHero;
